// src/pages/Admin/VotePage/hooks/useVotesAdmin.js

import { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";

import {
  deleteVote,
  getAllVotes,
} from "../../../../services/voteServices";

export default function useVotesAdmin() {
  const [votes, setVotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [deletingId, setDeletingId] = useState(null);

  const loadVotes = useCallback(async ({ silent = false } = {}) => {
    if (silent) {
      setRefreshing(true);
    } else {
      setLoading(true);
    }

    try {
      const data = await getAllVotes();

      setVotes(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error(
        "Erreur lors du chargement des votes :",
        error,
      );

      toast.error("Impossible de charger les votes et sondages.");
      setVotes([]);
    } finally {
      setLoading(false);
      setRefreshing(false);
    }
  }, []);

  useEffect(() => {
    loadVotes();
  }, [loadVotes]);

  const removeVote = useCallback(async (vote) => {
    if (!vote?.id) {
      return false;
    }

    const confirmed = window.confirm(
      `Supprimer définitivement « ${vote.title || "ce vote"} » ?`,
    );

    if (!confirmed) {
      return false;
    }

    setDeletingId(vote.id);

    try {
      await deleteVote(vote.id);

      setVotes((currentVotes) =>
        currentVotes.filter(
          (currentVote) => currentVote.id !== vote.id,
        ),
      );

      toast.success("Vote supprimé.");
      return true;
    } catch (error) {
      console.error(
        "Erreur lors de la suppression du vote :",
        error,
      );

      toast.error("Le vote n’a pas pu être supprimé.");
      return false;
    } finally {
      setDeletingId(null);
    }
  }, []);

  return {
    votes,
    loading,
    refreshing,
    deletingId,
    loadVotes,
    removeVote,
  };
}